/**
 * Resolve a CSS custom property to a color string that ECharts/Canvas can use.
 *
 * Strategy: apply the `var(...)` to a temporary element, let the browser
 * compute the final color, then:
 *   1. If the browser normalized it to `rgb()` / `rgba()`, normalize to rgb().
 *   2. Otherwise return the computed value verbatim. Modern Canvas 2D (Chrome
 *      111+, Safari 16.4+) accepts `oklch()` and `color(srgb ...)` directly,
 *      so passing the literal through still works and keeps the chart on the
 *      same colors the rest of the app uses.
 */
export function resolveThemeColor(variable: string): string {
  const el = document.createElement('div');
  el.style.color = `var(${variable})`;
  document.body.appendChild(el);
  const resolved = getComputedStyle(el).color;
  document.body.removeChild(el);

  const match = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(resolved);
  if (match) {
    return `rgb(${match[1] ?? '0'}, ${match[2] ?? '0'}, ${match[3] ?? '0'})`;
  }

  if (resolved) return resolved;

  // Fallback — indigo-600, matches the default --primary token.
  return '#4f46e5';
}
